/* eslint-disable */
// source: vivacity/config/viu_config.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

goog.exportSymbol('proto.vivacity.config.Viu', null, global);
goog.exportSymbol('proto.vivacity.config.Viu.ArchitectureTypes', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vivacity.config.Viu = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vivacity.config.Viu, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vivacity.config.Viu.displayName = 'proto.vivacity.config.Viu';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vivacity.config.Viu.prototype.toObject = function(opt_includeInstance) {
  return proto.vivacity.config.Viu.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vivacity.config.Viu} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vivacity.config.Viu.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    releaseTimeoutSeconds: jspb.Message.getFieldWithDefault(msg, 2, 0),
    heartbeatIntervalMilliseconds: jspb.Message.getFieldWithDefault(msg, 3, 0),
    supermarioImageTag: jspb.Message.getFieldWithDefault(msg, 4, ""),
    unsetFBitsTimeoutSeconds: jspb.Message.getFieldWithDefault(msg, 6, 0),
    hwmanHeartbeatRateSeconds: jspb.Message.getFieldWithDefault(msg, 7, 0),
    hardwareId: jspb.Message.getFieldWithDefault(msg, 8, 0),
    architectureTypeId: jspb.Message.getFieldWithDefault(msg, 9, 0),
    ttyDevicePath: jspb.Message.getFieldWithDefault(msg, 10, ""),
    extraValuesJson: jspb.Message.getFieldWithDefault(msg, 11, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vivacity.config.Viu}
 */
proto.vivacity.config.Viu.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vivacity.config.Viu;
  return proto.vivacity.config.Viu.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vivacity.config.Viu} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vivacity.config.Viu}
 */
proto.vivacity.config.Viu.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setReleaseTimeoutSeconds(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setHeartbeatIntervalMilliseconds(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSupermarioImageTag(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setUnsetFBitsTimeoutSeconds(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setHwmanHeartbeatRateSeconds(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setHardwareId(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setArchitectureTypeId(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setTtyDevicePath(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setExtraValuesJson(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vivacity.config.Viu.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vivacity.config.Viu.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vivacity.config.Viu} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vivacity.config.Viu.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getReleaseTimeoutSeconds();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getHeartbeatIntervalMilliseconds();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getSupermarioImageTag();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getUnsetFBitsTimeoutSeconds();
  if (f !== 0) {
    writer.writeUint32(
      6,
      f
    );
  }
  f = message.getHwmanHeartbeatRateSeconds();
  if (f !== 0) {
    writer.writeUint32(
      7,
      f
    );
  }
  f = message.getHardwareId();
  if (f !== 0) {
    writer.writeUint32(
      8,
      f
    );
  }
  f = message.getArchitectureTypeId();
  if (f !== 0) {
    writer.writeUint32(
      9,
      f
    );
  }
  f = message.getTtyDevicePath();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getExtraValuesJson();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.vivacity.config.Viu.ArchitectureTypes = {
  AMD64: 0,
  ARM: 1
};

/**
 * optional uint32 id = 1;
 * @return {number}
 */
proto.vivacity.config.Viu.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.vivacity.config.Viu} returns this
 */
proto.vivacity.config.Viu.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint32 release_timeout_seconds = 2;
 * @return {number}
 */
proto.vivacity.config.Viu.prototype.getReleaseTimeoutSeconds = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.vivacity.config.Viu} returns this
 */
proto.vivacity.config.Viu.prototype.setReleaseTimeoutSeconds = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional uint32 heartbeat_interval_milliseconds = 3;
 * @return {number}
 */
proto.vivacity.config.Viu.prototype.getHeartbeatIntervalMilliseconds = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.vivacity.config.Viu} returns this
 */
proto.vivacity.config.Viu.prototype.setHeartbeatIntervalMilliseconds = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string supermario_image_tag = 4;
 * @return {string}
 */
proto.vivacity.config.Viu.prototype.getSupermarioImageTag = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.vivacity.config.Viu} returns this
 */
proto.vivacity.config.Viu.prototype.setSupermarioImageTag = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional uint32 unset_f_bits_timeout_seconds = 6;
 * @return {number}
 */
proto.vivacity.config.Viu.prototype.getUnsetFBitsTimeoutSeconds = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.vivacity.config.Viu} returns this
 */
proto.vivacity.config.Viu.prototype.setUnsetFBitsTimeoutSeconds = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional uint32 hwman_heartbeat_rate_seconds = 7;
 * @return {number}
 */
proto.vivacity.config.Viu.prototype.getHwmanHeartbeatRateSeconds = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.vivacity.config.Viu} returns this
 */
proto.vivacity.config.Viu.prototype.setHwmanHeartbeatRateSeconds = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional uint32 hardware_id = 8;
 * @return {number}
 */
proto.vivacity.config.Viu.prototype.getHardwareId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.vivacity.config.Viu} returns this
 */
proto.vivacity.config.Viu.prototype.setHardwareId = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional uint32 architecture_type_id = 9;
 * @return {number}
 */
proto.vivacity.config.Viu.prototype.getArchitectureTypeId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.vivacity.config.Viu} returns this
 */
proto.vivacity.config.Viu.prototype.setArchitectureTypeId = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional string tty_device_path = 10;
 * @return {string}
 */
proto.vivacity.config.Viu.prototype.getTtyDevicePath = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.vivacity.config.Viu} returns this
 */
proto.vivacity.config.Viu.prototype.setTtyDevicePath = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string extra_values_json = 11;
 * @return {string}
 */
proto.vivacity.config.Viu.prototype.getExtraValuesJson = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.vivacity.config.Viu} returns this
 */
proto.vivacity.config.Viu.prototype.setExtraValuesJson = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


goog.object.extend(exports, proto.vivacity.config);
